export default __webpack_public_path__ + "static/media/TailGate.4722211c.png";